import { mapGetters } from 'vuex'

import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { FORM_TYPE } from 'enums/form-type'
import { CLEAN_USER_DETAILS } from 'enums/auth'

function getModelByType(formType, userDetails) {
  const FirstName = userDetails.FirstName || ''
  const LastName = userDetails.LastName || ''
  const Email = userDetails.Email || ''

  if (!formType) return { FirstName, LastName, Email }

  const FORM_MODEL = {
    [FORM_TYPE.CONTACT_US]: {
      FirstName,
      LastName,
      Email,
      Phone: '',
      CompanyName: '',
      DepartmentType: null,
      Message: ''
    },
    [FORM_TYPE.SUGGEST_A_TERM]: {
      Email
    },
    [FORM_TYPE.NEWSLETTER]: {
      Email
    },
    [FORM_TYPE.BECOME_AN_AUTHOR]: {
      FirstName,
      LastName,
      Email,
      CompanyName: '',
      PositionName: '',
      LinkedInProfileUrl: '',
      TwitterProfileUrl: '',
      MessageText: ''
    },
    [FORM_TYPE.EVENTS_STICKY_BUTTON]: {
      FirstName,
      LastName,
      Email,
      Company: '',
      Message: ''
    },
    [FORM_TYPE.EVENTS_MAILING_LIST]: {
      FirstName,
      LastName,
      Email
    },
    [FORM_TYPE.INTELLIGENCE_BUY_HERE]: {
      FirstName,
      LastName,
      Email,
      Company: '',
      Country: null,
      ValueAddedTaxIdentifier: ''
    },
    [FORM_TYPE.INTELLIGENCE_CUSTOM_REPORT]: {
      FirstName,
      LastName,
      Email,
      CompanyName: '',
      Message: ''
    },
    [FORM_TYPE.SEND_ME_AN_OFFER]: {
      FirstName,
      LastName,
      Email
    },
    [FORM_TYPE.HP_NEWSLETTER]: {
      FirstName,
      LastName,
      Email
    },
    [FORM_TYPE.ARTICLE_NEWSLETTER]: {
      Email
    }
  }

  return FORM_MODEL[formType]
}

export const prefilledForm = function(formType, updateFieldName = 'userForm') {
  return {
    mixins: [hydrationHelpers],
    data() {
      return {
        prefilledForm_needUpdate: true,
        prefilledForm_reRenderKey: this.$helper.guid()
      }
    },
    computed: {
      ...mapGetters({
        userDetails: 'auth/userDetails',
        isLoggedIn: 'auth/isLoggedIn'
      })
    },
    watch: {
      userDetails: {
        immediate: true,
        async handler({ Id }) {
          if (!process.client) return

          this.$helper.watchAndExecuteOnce({
            ctx: this,
            field: 'isMounted',
            conditionFn: newVal => !!newVal,
            immediate: true,
            handlerFn: () => {
              this.$_prefilledForm_handlePrefill(Id)
            }
          })
        }
      }
    },
    methods: {
      $_prefilledForm_handlePrefill(Id) {
        if (!Id) {
          this.$_prefilledForm_clearUserFormFromAuthorizationData()
          this.prefilledForm_needUpdate = true
          this.$nextTick(this.$_prefilledForm_changeRenderKey)
          return
        }

        if (!this.prefilledForm_needUpdate) return

        this.$_prefilledForm_assignUserForm()
        this.prefilledForm_needUpdate = false
        this.$nextTick(this.$_prefilledForm_changeRenderKey)
      },
      $_prefilledForm_assignUserForm() {
        const {
          FirstName,
          LastName,
          Email
        } = this.$_prefilledForm_getPrefilledModel()
        const userForm = this[updateFieldName]
        this[updateFieldName] = {
          ...userForm,
          FirstName: userForm.FirstName || FirstName,
          LastName: userForm.LastName || LastName,
          Email: userForm.Email || Email
        }
      },
      $_prefilledForm_clearUserFormFromAuthorizationData() {
        const userForm = this[updateFieldName]

        // make sure we keep the data from query
        const { FirstName, LastName, Email } = this.$route.query

        this[updateFieldName] = {
          ...userForm,
          FirstName: FirstName || '',
          LastName: LastName || '',
          Email: Email || ''
        }
      },
      $_prefilledForm_getFormDataFromQuery(model) {
        const { query } = this.$route
        return Object.keys(model).reduce((acc, key) => {
          const valueFromQuery = query[key]

          if (valueFromQuery) {
            acc[key] = valueFromQuery
          }

          return acc
        }, {})
      },
      $_prefilledForm_getPrefilledModel() {
        const userDetails = this.isMounted
          ? this.$store.getters['auth/userDetails']
          : CLEAN_USER_DETAILS

        const model = getModelByType(formType, userDetails)
        const userDetailsFromQuery = this.$_prefilledForm_getFormDataFromQuery(
          model
        )

        return {
          ...model,
          ...userDetailsFromQuery
        }
      },
      $_prefilledForm_changeRenderKey() {
        this.prefilledForm_reRenderKey = this.$helper.guid()
      }
    }
  }
}
